<template>
  <div class="insurance">
    <van-dialog
      v-model="show"
      title="中国人民财产保险股份有限公司服务协议（2023版）"
    >
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 28px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >《中国人民财产保险股份有限公司服务协议》（以下简称“本协议”）作为中国人民财产保险股份有限公司（以下简称“本公司”或“人保财险”）提供服务的依据，确定用户在何种条件、以何种方式使用人保财险服务平台（包括微信公众号、微信小程序等）及其服务。请您在完成登录注册前，认真阅读本协议，当您点击登陆或注册按钮即代表您已完全阅读并同意所有服务条款，并自愿遵守本协议。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >本协议条款是对双方权利义务的约定依据。人保财险有权随时对本协议内容进行单方面变更，并以平台公告的方式予以公布，无需另行单独通知。在人保财险使用服务和（或）购买产品的同时，您也承认了您拥有购买、使用相关产品的权利和行为能力，并且对您在订单和（或）服务中提供的所有信息真实性负责。并且在同意本协议同时，表明您已经同意</span
        ><a href="http://smsp.epicc.com.cn:9101/app/wapapp/deal/privacy.html"
          ><span
            style="
              font-size: 16px;
              font-family: 仿宋_GB2312;
              color: #333333;
              text-underline: none;
            "
            >《中国人民财产保险股份有限公司隐私</span
          ><span
            style="
              font-size: 16px;
              font-family: 仿宋_GB2312;
              color: #333333;
              text-underline: none;
            "
            >政策</span
          ><span
            style="
              font-size: 16px;
              font-family: 仿宋_GB2312;
              color: #333333;
              text-underline: none;
            "
            >》</span
          ></a
        ><span
          style="
            font-size: 16px;
            font-family: '微软雅黑', 'sans-serif';
            color: #333333;
          "
          >&nbsp;</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >，允许使用、分享、披露您的个人信息等。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >与此同时，在您使用人保财险旗下各平台服务时，在本协议的基础上，您应当同时遵守单项服务协议的具体约定。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >一、用户主体</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >符合下列条件之一的自然人或者组织可以注册登陆成为本平台用户，但本平台不保证一定能通过注册登陆。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >您应当是具有完全民事权利能力和民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >您可使用人保财险认可的第三方账户/平台授权注册或直接登录人保财险自营平台，并自动成为人保财险用户。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >当您首次使用手机号验证码登陆时，将自动成为人保财险用户。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >二、用户信息</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >用户可能需要提供真实准确的联系方式、通讯地址、真实姓名或名称、个人资质文件等信息，完成注册登陆或使用本网站的服务。为了合法、合规地为用户提供更好的服务，本网站将不时增加或删除用户需提交的信息。如用户不同意提供上述信息，则应当停止使用本平台的服务。如用户提供的信息包含有不正当的信息，我们保留结束用户使用网络服务资格的权利。另外当您的身份信息及其他资料发生变化时，您应当及时更新并提供您最新的身份信息及资料。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >三、账户管理</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >您需自行对您的用户名和密码安全负全部责任，且对以其用户名和密码下发生的所有活动操作负全责。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >用户账号使用权仅属于初始注册人，禁止赠与、借用、转租、转让或售卖。如果发现使用者并非账号初始注册人，人保财险有权在未经通知的情况下回收该账号而无需向该账号使用人承担法律责任。如发生利用计算机程序进行恶意注册、邀请、参与的情形，我方有权在不事先通知用户的情况下单方面中断或终止向用户提供服务而无需通知用户。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >您了解并同意：本平台尽力保障您的账户安全但不保证您账号安全的绝对性，因他人未经授权使用您的账户密码造成的损失由您自行承担或依法由擅用人承担。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >4.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >在需要终止使用本服务时，您可以申请注销您的人保财险账户，您了解并同意：所申请的账户应当是您本人的人保财险账户，如需注销应当按照本公司规定的程序进行账号注销。注销将导致本公司终止为您提供本服务，但您还仍需对您在注销账号前且使用本服务期间的行为承担相应责任，包括但不限于可能产生的违约责任、损害赔偿责任及履约义务，同时本公司仍可保留您的相关信息，并做好相关保护工作。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >四、隐私声明</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >您了解并同意，人保财险将按照</span
        ><span
          style="
            font-size: 16px;
            font-family: '微软雅黑', 'sans-serif';
            color: #333333;
          "
          >&nbsp;</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >《</span
        ><a href="http://smsp.epicc.com.cn:9101/app/wapapp/deal/privacy.html"
          ><span
            style="
              font-size: 16px;
              font-family: 仿宋_GB2312;
              color: #333333;
              text-underline: none;
            "
            >中国人民财产保险股份有限公司隐私政策》</span
          ></a
        ><span
          style="
            font-size: 16px;
            font-family: '微软雅黑', 'sans-serif';
            color: #333333;
          "
          >&nbsp;</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >保护您的个人信息，对您的隐私资料进行保护，承诺不会在未获得用户许可的情况下擅自将用户的个人资料信息出租或出售给任何第三方。人保财险将在公司平台上公布并有权不时修改</span
        ><a href="http://smsp.epicc.com.cn:9101/app/wapapp/deal/privacy.html"
          ><span
            style="
              font-size: 16px;
              font-family: 仿宋_GB2312;
              color: #333333;
              text-underline: none;
            "
            >《中国人民财产保险股份有限公司隐私政策》</span
          ></a
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >，</span
        ><a href="http://smsp.epicc.com.cn:9101/app/wapapp/deal/privacy.html"
          ><span
            style="
              font-size: 16px;
              font-family: 仿宋_GB2312;
              color: #333333;
              text-underline: none;
            "
            >《中国人民财产保险股份有限公司隐私政策》</span
          ></a
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >构成本协议的有效组成部分。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >五、服务中断及不可抗力</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >本平台因下列状况导致服务暂停或中断的，本公司不承担违约或赔偿服务：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >）因自然灾害如洪水、台风、火灾、爆炸、雷电、地震和风暴等以及社会事件如停电、战争、动乱、恐怖袭击、政府行为、国家政策的突然变动和罢工等不可抗力之因素，造成本平台系统障碍不能提供服务的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >）黑客攻击；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >c</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >）网络、电信设备出现故障不能进行数据传输的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >d</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >）云服务系统、计算机系统遭到破坏、瘫痪或无法正常使用而导致信息或记录的丢失；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >e)</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >电信技术部门调整或故障、网站升级、银行方面。支付渠道的问题等原因而造成的服务中断或者延迟；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >f</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >）因政府管制而造成的暂时关闭；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >g</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >）病毒侵袭；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >h</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >）其他。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >本公司需要定期或不定期地对提供本系统服务系统及其相关的设备进行检修或者维护，如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，本公司无需为此承担任何责任。本公司保留不经事先通知为维修保养、升级或其他目的暂停本服务任何部分的权利。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >六、责任声明</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >本公司仅对本协议中列明的责任承担范围责任。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >您明确因使用本服务从事的交易所产生的任何风险应当由您与交易对方承担。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >本公司用户信息是由用户本人自行提供，本公司无法保证该信息之准确、及时和完整，您应对您的判断承担全部责任。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >4.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >您自本公司及本公司工作人员或经由本服务取得之建议和资讯，无论其为书面或口头形式，均不构成本公司对本服务之保证。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >5.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >在任何情况下，本公司对于与本协议有关或由本协议引起的任何间接的、惩罚性的、特殊的、派生的损失（包括业务损失、收益损失、利润损失、商誉损失、使用数据或其他经济利益的损失），不论是如何产生的，也不论是由对本协议的违约（包括违反保证）还是由侵权造成的，均不负有任何责任，即使事先已被告知此等损失的可能性。另外即使本协议规定的排他性救济没有达到其基本目的，也应排除本公司对上述损失的责任。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >6.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >在任何情况下，本公司对本协议所承担的违约赔偿责任总额不超过向您收取的当次服务费用总额。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >7.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >您充分知晓并同意本公司可能同时为您及您的对手方提供本服务，您同意本公司可能存在的该等行为予以明确豁免任何实际或潜在的利益冲突，并不得以此来主张本公司在提供本服务时存在法律上的瑕疵。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >8.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >除本协议另有规定或本公司另行同意外，您对本公司的委托及向本公司发出的指令均不可撤销。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >七、知识产权声明</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >人保财险官方平台上所有智力成果、可阅读资料等都受到《中华人民共和国著作权法》等的法律保护，包括但不限于数据库、软件、著作、照片、录像、音乐、声音及前述组合，软件编译、相关源代码和软件档案、咨询、资料、架构、页面设计。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >人保财险官方平台的所有内容选材、整理、编排、排版，以及由中国人保财险或本公司关联企业的文字、图片等作品的著作权，无论是否明示，均属中国人保财险所有。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >任何组织或个人未经人保财险书面许可，不得修改、出版、传播、参与传播、销售、制作衍生作品，或以其他任何方式使用整体或部分的人保财险网上内容。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >4.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >尊重知识产权是您应尽的义务，如有违反，您应承担损害赔偿责任。</span
        >
      </p>
      <h3
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 黑体; color: black"
          >八、法律适用、管辖与其他</span
        >
      </h3>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 43px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: #333333"
          >本协议条款的解释及适用，以及与本协议条款有关的争议，均应依照中华人民共和国大陆地区法律予以处理，如因本协议产生争议，您同意以本公司所在地人民法院为第一审管辖法院。</span
        >
      </p>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="less" scoped>
.insurance {
  /deep/.van-dialog__header {
    color: #323233;
    font-weight: 700;
    font-size: 17px;
  }
  /deep/.van-dialog__content {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    max-height: 60vh;
    padding: 8px 24px 26px 24px;
    overflow-y: auto;
    font-size: 14px;
    line-height: 20px;
    white-space: pre-wrap;
    text-align: center;
    word-wrap: break-word;
    -webkit-overflow-scrolling: touch;
  }
}
</style>